import React, { PropTypes } from 'react';
import { FlatButton, Dialog } from 'material-ui';

const UnsupportedBrowserDialog = props => {
  const {
    buttonText,
    title,
    errorMessage,
    confirmationFunc,
  } = props;

  return (
    <Dialog
      title={title}
      actions={
        <FlatButton
          label={buttonText}
          secondary
          onTouchTap={confirmationFunc}
        />
      }
      modal={false}
      open
    >
      {errorMessage}
    </Dialog>
  );
};

UnsupportedBrowserDialog.propTypes = {
  buttonText: PropTypes.string,
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  confirmationFunc: PropTypes.func,
};

export default UnsupportedBrowserDialog;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/unsupported-browser.jsx